define("ember-svg-jar/inlined/light-bulb", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<path d=\"M8.5 15.172a1.723 1.723 0 01-1.517-.872c-.417 0-.775-.149-1.072-.446a1.46 1.46 0 01-.445-1.071V10.09a5.496 5.496 0 01-1.793-1.954A5.346 5.346 0 013 5.5c0-1.53.534-2.829 1.603-3.897C5.67.534 6.97 0 8.5 0c1.53 0 2.829.534 3.897 1.603C13.466 2.67 14 3.97 14 5.5c0 .974-.224 1.859-.673 2.655a5.544 5.544 0 01-1.793 1.935v2.693c0 .417-.148.774-.445 1.071a1.461 1.461 0 01-1.072.446 1.723 1.723 0 01-1.517.872zm-1.517-2.39h3.034V12.1H6.983v.683zm0-1.44h3.034v-.721H6.983v.72zM6.83 9.102h1.1V7.055L6.262 5.386l.797-.796L8.5 6.03 9.941 4.59l.797.796-1.669 1.67v2.047h1.1a4.154 4.154 0 001.669-1.45c.43-.639.645-1.356.645-2.153 0-1.113-.386-2.055-1.157-2.826-.771-.771-1.713-1.157-2.826-1.157s-2.055.386-2.826 1.157c-.771.771-1.157 1.713-1.157 2.826 0 .797.215 1.514.645 2.153.43.638.986 1.122 1.669 1.45z\" fill=\"currentColor\"/>",
    "attrs": {
      "width": "17",
      "height": "16",
      "viewBox": "0 0 17 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  };
});